import { render, staticRenderFns } from "./ContractHistory.vue?vue&type=template&id=19298e72&scoped=true"
import script from "./ContractHistory.vue?vue&type=script&lang=js"
export * from "./ContractHistory.vue?vue&type=script&lang=js"
import style0 from "./ContractHistory.vue?vue&type=style&index=0&id=19298e72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19298e72",
  null
  
)

export default component.exports